import React from "react";
import styled from "styled-components";
import { Icon, Text } from "components/atoms";

type PremiumBadgeSize = "small" | "large";

interface PremiumBadgeProps {
  /** small=헤더, large=현황 탭 멤버십 섹션 */
  size?: PremiumBadgeSize;
  /** 배지 라벨 (기본 "Premium") */
  label?: string;
}

const SIZE_SPEC: Record<
  PremiumBadgeSize,
  { padding: string; radius: string; iconSize: number; textType: "Body1SemiBold" | "Body2SemiBold" }
> = {
  // 헤더 로컬 styled(CommonHeader)와 1:1
  small: { padding: "6px 14px", radius: "16px", iconSize: 14, textType: "Body2SemiBold" },
  large: { padding: "8px 18px", radius: "20px", iconSize: 18, textType: "Body1SemiBold" },
};

/**
 * 프리미엄(멤버십 활성) 마크. 골드 그라데이션 pill + Star.
 * 헤더(small)·현황 탭 멤버십 섹션(large)에서 공통 사용.
 */
const PremiumBadge: React.FC<PremiumBadgeProps> = ({ size = "small", label = "Premium" }) => {
  const spec = SIZE_SPEC[size];
  return (
    <Badge padding={spec.padding} radius={spec.radius}>
      <Icon name="Star" size={spec.iconSize} color="#FFF" />
      <Text textType={spec.textType} color="#FFF">
        {label}
      </Text>
    </Badge>
  );
};

export default PremiumBadge;

const Badge = styled.div<{ padding: string; radius: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: ${(p) => p.padding};
  background: linear-gradient(135deg, #ffd700, #ffa500);
  border-radius: ${(p) => p.radius};
  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.2);
`;
